module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7efe6c760528470b8574e5536b205d20.png";